import { render, staticRenderFns } from "./FaturasCadastradas.vue?vue&type=template&id=2cc46afc&scoped=true"
import script from "./FaturasCadastradas.vue?vue&type=script&lang=js"
export * from "./FaturasCadastradas.vue?vue&type=script&lang=js"
import style0 from "./FaturasCadastradas.vue?vue&type=style&index=0&id=2cc46afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc46afc",
  null
  
)

export default component.exports